import * as React from 'react';
import { useCallback, useState } from 'react';
import classNames from 'classnames';

import type { Without } from '@/types/generic';

// TODO: fix typings
export type UIDateProps = any; // {
//   name: string;
//   value?: string;
//   onChange?: (value: string) => void;
// } & Without<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'>;

export const UIDate =
  ({ name, value, onChange, ...inputProps }: UIDateProps) => {
    const [selectedValue, setSelected] = useState('');
    const [focused, setFocused] = useState(false);
    const handleChange = useCallback<React.InputHTMLAttributes<HTMLInputElement>['onChange']>((event) => {
      const { value: newValue } = event.target;
      onChange?.(newValue);
      if (typeof value !== 'undefined') setSelected(newValue);
    }, [onChange, setSelected, typeof value]);
    const handleFocus = useCallback(() => setFocused(true), [setFocused]);
    const handleBlur = useCallback(() => setFocused(false), [setFocused]);

    const valueToUse = typeof value === 'undefined' ? selectedValue : value;
    return (
      <div className={classNames('ui-input-text', 'ui-body-inherit', 'ui-corner-all', 'ui-shadow-inset', focused && 'ui-focus')}>
        <input
          type="date"
          name={name}
          id={name}
          data-role="none"
          value={valueToUse}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...inputProps} // eslint-disable-line react/jsx-props-no-spreading
        />
      </div>
    );
  };
